// extracted by mini-css-extract-plugin
export default {"headerContainer":"ccf-app-agent-messages_headerContainer__uhc5U","headerText":"ccf-app-agent-messages_headerText__ASabw"};